<div class="wrapper">
  <button
    class="bell-button"
    themeColor="primary"
    kendoPopoverAnchor
    #anchor="kendoPopoverAnchor"
    [popover]="notificationsPopover"
    (click)="onBellButtonClick($event)">
    <span class="k-icon k-font-icon k-i-bell bell"></span>
  </button>
  @if (hasUnreadNotifications) {
    <span class="unread-notifications">{{ unreadNotifications }}</span>
  }
</div>

<kendo-popover #notificationsPopover [width]="750" position="bottom">
  <ng-template kendoPopoverTitleTemplate>
    <div class="header-wrapper">
      <div class="title">
        <span>Notifications</span>
      </div>
      <div class="navigation-buttons"></div>
      <div class="generic-buttons">
        @if (canDisplayNotificationsSetup()) {
          <span
            class="k-icon k-font-icon k-i-gear icon-button"
            kendoTooltip
            (click)="displayNotificationsSetup()"
            title="Rules"></span>
        }
      </div>
    </div>
  </ng-template>
  <ng-template kendoPopoverBodyTemplate>
    <!-- Currently we have only work-item notifications: in future we have to provide choices for additional types -->
    <app-notifications-list-work-items
      [statisticsSlice]="workItemsStatisticsSlice"
      (navigate)="navigateToWorkItems($event)"
      (statusChanged)="reloadStatistics()"></app-notifications-list-work-items>
  </ng-template>
</kendo-popover>
